/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ElementFromJSON, ElementToJSON, PresentationFromJSON, PresentationToJSON, } from './';
export function ElementGroupElementPresentationFromJSON(json) {
    return ElementGroupElementPresentationFromJSONTyped(json, false);
}
export function ElementGroupElementPresentationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'element': !exists(json, 'element') ? undefined : ElementFromJSON(json['element']),
        'presentation': !exists(json, 'presentation') ? undefined : PresentationFromJSON(json['presentation']),
    };
}
export function ElementGroupElementPresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'element': ElementToJSON(value.element),
        'presentation': PresentationToJSON(value.presentation),
    };
}
//# sourceMappingURL=ElementGroupElementPresentation.js.map